import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepThreeCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepThreeCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.discoverStepThreeCollections.data.discoverStepThreeCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.discoverStepThreeCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
